export const planPricingLevelConstants = {
  ID: 'id',

  NAME: 'name',
  NAME_LABEL: 'Name',

  PRICING_LEVEL_LABEL: 'Pricing Level',

  ORDER: 'order',
  ORDER_LABEL: 'Order',

  SEARCH_PRICING_LEVEL: 'Search Pricing Levels',
};
